<script>
export default {
    name: "AssignStore",

    props: {

        showModal: Boolean,
        stores: Array,
        user: Object,
    },

    methods: {

        saveAssignStore(store) {
            this.$root.loading=true;
            const assign = {
                userID: this.user.code,
                storeID: store.id,
                status: store.status,
                userName: this.$root.username,
            };
            this.$http.post(`Admin/AssignUserStoreRights`, assign).then(() => {
                
                this.$root.loading=false;
            }).catch(() => {this.$root.loading=false;})
        },
    },
}
</script>
<template>
<tail-modal :show="showModal" dimension="md:w-1/3">
  <template v-slot:title>
    <h5 class="font-medium text-sm">Assign Store</h5>
  </template>
  <template v-slot:modal-body>
    <div class="flex flex-wrap w-full items-center">
      <div class="w-full p-1 text-center my-2">
          <h5 class="font-medium text-sm">{{user.userName}}</h5>
      </div>
      <div class="w-full overflow-auto p-1">
          <table class="table">
              <thead class="bg-blue-500 text-white text-xs">
                  <tr class="w-full flex">
                      <th class="p-tiny flex-1">Store</th>
                      <th class="p-tiny flex-1">Action</th>
                  </tr>
              </thead>
              <tbody class="text-xs bg-gray-100 flex flex-col items-center max-h-screen overflow-auto">
                  <tr class="w-full flex" v-for="store in stores" :key="store.id">
                      <td class="p-tiny flex-1">{{store.name}}</td>
                      <td class="p-tiny flex-1">
                          <input type="checkbox" @change.stop="saveAssignStore(store)"
                            v-model="store.status" class="h-5 w-5">
                      </td>
                  </tr>
              </tbody>
          </table>
      </div>
    </div>
  </template>
  <template v-slot:modal-footer>
    <button class="btn-danger btn-sm text-xs rounded" 
        @click.prevent="$emit(`closeModal`)">
            <i class="fa fa-times"></i> Close</button>
  </template>
</tail-modal>
</template>
